import { render } from "./DailyPushView.vue?vue&type=template&id=56e4b55f"
import script from "./DailyPushView.vue?vue&type=script&lang=js"
export * from "./DailyPushView.vue?vue&type=script&lang=js"

import "./DailyPushView.vue?vue&type=style&index=0&id=56e4b55f&lang=css"

import exportComponent from "C:\\Users\\AloneX\\taipeitest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__